import { render, staticRenderFns } from "./ag-product-badge.vue?vue&type=template&id=c0b89946"
import script from "./ag-product-badge.vue?vue&type=script&lang=js"
export * from "./ag-product-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports